/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AccountSubscriptionTier {
  FREE = 'free',
  STARTER = 'starter',
  STANDARD = 'standard',
  PRO = 'pro',
  ULTRA = 'ultra',
  MAX = 'max',
  BUSINESS_PRO = 'business_pro',
  BUSINESS_ULTRA = 'business_ultra',
  BUSINESS_MAX = 'business_max',
  CREDIT_PRO = 'credit_pro',
  CREDIT_BUSINESS_PRO = 'credit_business_pro',
  INTERNAL_UNLIMITED = 'internal_unlimited',
}
